<template>
  <a-modal
    :visible="visible"
    width="450px"
    :body-style="bodyStyle"
    centered
    :footer="null"
    @cancel="handleCloseModalHeader"
  >
    <div class="container__inactive">
      <img class="image__delete" src="@/app/users/assets/profiles/delete.png" alt="profile" />
      <p class="text__alert">¿Estás seguro de eliminar a</p>
      <p class="text__alert">“{{ record.first_name }} {{ record.last_name }}”?</p>
    </div>
    <div class="container__info">
      <p class="text">Sucederán las siguientes acciones:</p>
      <ul>
        <li>Se desactivará de estrategias, colas y campañas a las que esté asociado.</li>
        <li>
          De tener tickets activos se reenviarán a su cola respectiva para que sean atendidos.
        </li>
        <li>
          Se quitara de la lista de usuarios y no se cobrará este usuario en la siguiente
          facturación.
        </li>
      </ul>
    </div>
    <a-form v-if="type == 'User'" class="form" layout="vertical">
      <a-row :gutter="24">
        <a-col span="24">
          <a-form-item class="form__item">
            <template #label>
              <span> Escribe la palabra <span class="strong">Eliminar</span> </span>
            </template>
            <a-input v-model:value="confirmText" placeholder="Escribe aquí..."></a-input>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
    <div class="button__disabled">
      <a-button
        style="width: 100%"
        :disabled="type == 'User' && confirmText !== 'Eliminar'"
        class="footer__delete"
        type="primary"
        @click="handleCloseModal"
      >
        Eliminar cuenta
      </a-button>
    </div>
  </a-modal>
</template>

<script>
import { defineComponent, ref } from "vue";
import { UserStatus } from "@/app/shared/utils/enums";
import { deleteUserSocket } from "@/app/shared/services";

export default defineComponent({
  name: "InactiveUserModal",
  components: {},
  props: {
    type: {
      type: String,
      default: "",
    },
    record: {
      type: Object,
      default: null,
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const confirmText = ref("");
    const bodyStyle = {
      height: props.type == "User" ? "515px" : "430px",
      loading: false,
    };

    return {
      confirmText,
      bodyStyle,
    };
  },
  data() {
    return {
      UserStatus,
    };
  },
  computed: {
    usersInfo() {
      return this.$store.getters["getDataUser"];
    },
  },
  methods: {
    handleCloseModal() {
      this.$emit("onCancel");
      this.updateStatus();
    },
    handleCloseModalHeader() {
      this.$emit("onCancel");
    },
    async updateStatus() {
      try {
        this.$store.dispatch("deleteUser", this.record.id);
        await deleteUserSocket({
          customer_id: this.usersInfo.customer.id,
          user_id: this.record.id,
          title: "Un administrador ha eliminado tu cuenta",
          description: "Se procederá a cerrar tu sesión en los próximos",
        });
        this.$message.success("El usuario se eliminó correctamente");
        this.$emit("update");
      } catch (error) {
        this.$message.error("Error al eliminar el usuario");
      }
      this.$emit("onCloseModal");
    },
  },
});
</script>

<style lang="sass" scoped>
.image__delete
  margin-bottom: 10px
  margin-top: 10px

.text__alert
  font-size: 16px
  font-weight: 600
  margin: 0

.text
  margin-bottom: 20px

.button__disabled
  margin-top: -2px

.strong
  font-weight: 600

.footer__delete
  margin-bottom: 20px

.container__inactive
  text-align: center
  color: $gray-13

.container__info
  margin-bottom: 18px
  color: $gray-8

.text
  margin-top: 20px
  margin-bottom: 12px
</style>
